import { render, staticRenderFns } from "./Asset3DInputField.vue?vue&type=template&id=aba994a2&scoped=true"
import script from "./Asset3DInputField.vue?vue&type=script&lang=ts"
export * from "./Asset3DInputField.vue?vue&type=script&lang=ts"
import style0 from "./Asset3DInputField.vue?vue&type=style&index=0&id=aba994a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba994a2",
  null
  
)

export default component.exports